function runAutoDiscount() {
  // ---------------------------------------------------------
  // CONFIG DES COLLECTIONS PAR REMISE
  // ---------------------------------------------------------
  
  //const collections15 = ["LES MINI CRÉOLES","COLLECTION FESTON","PAMPILLES MINI ETOILES","COLLECTION MINI PAPILLONS","LA DOLCE VITA","PAMPILLES MINI COEUR","BEST-SELLERS","PAMPILLES FLEUR TIARE","PAMPILLES MINI FLEURS","PAMPILLES NATURE","PAMPILLES GOURMANDISE","PAMPILLES NOEUD","LES CRÉOLES","PAMPILLES FLEUR","COLLECTION LOTUS","PAMPILLES COQUILLAGE","PAMPILLES LUNA","PAMPILLES BUBBLE","PAMPILLES COEUR","LES BROCHES","BRACELETS AURA","PAMPILLES ROSALINE","BARRETTES FLEUR","LES JETONS CADDIE","CHOUCHOUS"];
  
  const collections15 = ["COLLECTION FESTON","PAMPILLES MINI ETOILES","COLLECTION MINI PAPILLONS","LA DOLCE VITA","PAMPILLES MINI COEUR","BEST-SELLERS","PAMPILLES FLEUR TIARE","PAMPILLES MINI FLEURS","PAMPILLES NATURE","PAMPILLES GOURMANDISE","PAMPILLES NOEUD","PAMPILLES FLEUR","COLLECTION LOTUS","PAMPILLES COQUILLAGE","PAMPILLES LUNA","PAMPILLES BUBBLE","PAMPILLES COEUR","LES BROCHES","BRACELETS AURA","PAMPILLES ROSALINE","BARRETTES FLEUR","LES JETONS CADDIE","CHOUCHOUS"];
  
  const collections20 = ["FIN DE SÉRIE"];

  const collections30 = [""];

  const collections40 = [""];

  function getDiscountForCollections(collections) {
    if (collections.some((c) => collections40.includes(c))) {
      return { rate: 0.4, label: "-40%" };
    }
    if (collections.some((c) => collections30.includes(c))) {
      return { rate: 0.3, label: "-30%" };
    }
    if (collections.some((c) => collections20.includes(c))) {
      return { rate: 0.2, label: "-20%" };
    }
    if (collections.some((c) => collections15.includes(c))) {
      return { rate: 0.15, label: "-15%" };
    }
    return { rate: 0, label: "" };
  }

  function parseCollections(attr) {
    if (!attr) return [];
    return attr
      .split(",")
      .map((c) => c.trim())
      .filter((c) => c.length > 0);
  }

  // ---------------------------------------------------------
  // 1) PAGE PRODUIT
  // ---------------------------------------------------------
  (function handleProductPage() {
    const priceContainer = document.querySelector(".price__container");
    const productDataEl = document.querySelector(
      ".product-discount-data, [data-product-collections]"
    );
    if (!priceContainer || !productDataEl) return;

    // déjà appliqué sur cette page ? on sort
    if (priceContainer.dataset.discountApplied === "true") return;

    const collections = parseCollections(
      productDataEl.getAttribute("data-product-collections")
    );
    const { rate: discountRate, label: discountLabel } =
      getDiscountForCollections(collections);
    if (discountRate === 0) return;

    // Texte spécifique pour la page produit
    const productBadgeText = `${discountLabel}`;

    const dataPriceEl =
      document.querySelector("[data-product-price]") || productDataEl;
    if (!dataPriceEl) return;

    const displayPriceEl =
      priceContainer.querySelector("[data-product-price-display]") ||
      priceContainer.querySelector(
        ".price-item--regular, .price__regular, .price-item--sale"
      );
    if (!displayPriceEl) return;

    const rawPrice =
      dataPriceEl.dataset.productPrice ||
      dataPriceEl.getAttribute("data-product-price");
    const originalPrice = parseFloat(rawPrice) / 100;
    if (isNaN(originalPrice)) return;

    const discounted = originalPrice * (1 - discountRate);

    // marquer comme déjà traité AVANT d'ajouter le HTML
    priceContainer.dataset.discountApplied = "true";

    const compareContainer = document.createElement("div");
    compareContainer.className = "auto-discount-banner";
    compareContainer.innerHTML = `
      <div style="margin-bottom:6px;">
        <span style="font-size:18px; text-decoration:line-through; color:#666; margin-right:8px;">
          ${originalPrice.toFixed(2)} €
        </span>
        <span style="background:#d81b60; color:white; padding:3px 6px; border-radius:5px; font-size:14px;">
          ${productBadgeText}
        </span>
      </div>
    `;

    priceContainer.prepend(compareContainer);
    displayPriceEl.innerHTML = `<strong>${discounted.toFixed(2)} €</strong>`;
  })();

  // ---------------------------------------------------------
  // 2) CARDS PRODUIT (grilles / collections + "Vous aimerez aussi")
  // ---------------------------------------------------------
  function handleProductCards() {
    const cards = document.querySelectorAll(".card-information");

    cards.forEach((card) => {
      const collectionsAttr = card.getAttribute("data-product-collections");
      const priceAttr = card.getAttribute("data-product-price");

      if (!collectionsAttr || !priceAttr) return;

      const collections = parseCollections(collectionsAttr);
      const { rate: discountRate, label: discountLabel } =
        getDiscountForCollections(collections);
      if (discountRate === 0) return;

      const originalPrice = parseFloat(priceAttr) / 100;
      if (isNaN(originalPrice)) return;

      const discounted = originalPrice * (1 - discountRate);

      const priceContainer =
        card.querySelector(".price__container") || card;
      const displayPriceEl =
        card.querySelector("[data-card-price-display]") ||
        card.querySelector(".price-item--regular, .price__regular");
      if (!displayPriceEl || !priceContainer) return;

      // Avant d'ajouter, on supprime toutes les anciennes bannières sur cette card
      priceContainer
        .querySelectorAll(".auto-discount-banner")
        .forEach((el) => el.remove());

      const compareContainer = document.createElement("div");
      compareContainer.className = "auto-discount-banner";
      compareContainer.innerHTML = `
        <div style="margin-bottom:4px;">
          <span style="font-size:14px; text-decoration:line-through; color:#666; margin-right:6px;">
            ${originalPrice.toFixed(2)} €
          </span>
          <span style="background:#d81b60; color:white; padding:2px 5px; border-radius:4px; font-size:12px;">
            ${discountLabel}
          </span>
        </div>
      `;

      priceContainer.prepend(compareContainer);
      displayPriceEl.textContent = `${discounted.toFixed(2)} €`;
    });
  }

  // exécution immédiate pour toutes les cards déjà présentes (pages collections, etc.)
  handleProductCards();

  // ---------------------------------------------------------
  // 3) OBSERVER : nouvelles cards ajoutées (ex. "Vous aimerez aussi")
  // ---------------------------------------------------------
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;

    for (const m of mutations) {
      // si un nouveau .card-information apparaît, on relance handleProductCards
      if (
        (m.addedNodes && m.addedNodes.length > 0) ||
        m.type === "childList"
      ) {
        m.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.classList &&
            node.classList.contains("card-information")
          ) {
            shouldRun = true;
          }
          if (
            node.nodeType === 1 &&
            node.querySelector &&
            node.querySelector(".card-information")
          ) {
            shouldRun = true;
          }
        });
      }
    }

    if (shouldRun) {
      handleProductCards();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// lancement initial
document.addEventListener("DOMContentLoaded", runAutoDiscount);